/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"
import { Table } from "react-bootstrap"
import dayjs from "dayjs"
import util from "../../../../ts/util"
import HaisyaTableCell from "./HaisyaTableCell"
import MonthlyHaisyaTableCard from "./MonthlyHaisyaTableCard"
import {
  ZyomuinListContext,
  SearchConditionContext,
  SelectCellContext,
} from "../HaisyaContext"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"
import { AppDispatch } from "../../../.."
import { useDispatch, useSelector } from "react-redux"
import {
  THaisyaListGetReq,
  T車輌乗務員,
} from "../../../../service/order/haisya/THaisya"
import { e勤怠区分, T勤怠区分 } from "../../../../constant/enum/unko"
import { setAlerts } from "../../../../globalStore/alertStore"
import HaisyaService from "../../../../service/order/haisya/HaisyaService"
import { 当日全配車 } from "../haisyaRegisterUtil"
import { RootState } from "../../../../globalStore/rootreducer"
import dateUtil from "../../../../ts/util/dateUtil"

export const focusTargetId = `monthlyKijunTumibi`

/**
 * 配車入力（月単位）
 * @returns
 */
const MonthlyTab = () => {
  const [日付List, set日付List] = useState<string[]>([])
  const [wjMenu, setWjMenu] = useState<wjcInput.Menu>()
  const dispatch: AppDispatch = useDispatch()
  const 休日List = useSelector((state: RootState) => state.date.休日List)
  // TODO: onMenuClickメソッド内にuseContextの更新内容が反映されないためrefに逃がして確認する
  const select乗務員 = useRef<T車輌乗務員>()
  const select積日 = useRef<string>()
  const searchConditionRef = useRef<THaisyaListGetReq>()

  const { 車輌乗務員List: 乗務員List, set車輌乗務員List: set乗務員List } =
    useContext(ZyomuinListContext)
  const searchCondition = useContext(SearchConditionContext)
  const { chip, setIsModalShow, selectKey, setSelectData, setSelectKey } =
    useContext(SelectCellContext)

  const menuInitialized = (menu: wjcInput.Menu) => {
    setWjMenu(menu)
  }

  const onMenuClick = useCallback(
    async (menu: wjcInput.Menu) => {
      console.log(JSON.stringify(select乗務員.current))

      if (
        select乗務員 == null ||
        select乗務員.current == null ||
        select積日 == null ||
        select積日.current == null ||
        searchConditionRef == null ||
        searchConditionRef.current == null
      )
        return
      // 当日積日のデータと卸分割の受注で当日卸日のデータを集める
      const 当日配車 = 当日全配車(select乗務員.current, select積日.current)

      if (当日配車.length > 0) {
        alert("既に配車がされているため休暇にできません。")
        return
      }
      const 種別: T勤怠区分 | 0 = menu.selectedValue

      try {
        const service = new HaisyaService()
        const res = await service.kinmubiPost({
          乗務員ID: select乗務員.current.乗務員ID,
          勤務日: select積日.current,
          勤怠区分: 種別 !== 0 ? 種別 : undefined,
        })
        // 登録成功した場合、一覧の乗務員リストを更新
        if (res.data) {
          const ListRes = await service.getList(searchConditionRef.current)
          set乗務員List([...ListRes.data])
        }
      } catch (error) {
        dispatch(setAlerts(error))
      }
    },
    [select乗務員, select積日, searchConditionRef]
  )

  useEffect(() => {
    if (searchCondition == null || searchCondition.積日 == null) return
    const new日付List: string[] = []
    // 検索条件の月を表示する
    const day積日 = dayjs(searchCondition.積日)
    const 月末 = day積日.endOf("month").date()
    for (let day = 1; day <= 月末; day++) {
      new日付List.push(day積日.date(day).toISOString())
    }
    set日付List([...new日付List])
  }, [searchCondition])

  return (
    <div className="w-100 h-55rem overflow-scroll">
      {/* <Table bordered className="tumibi-table monthly">
       */}
      <Table className="tumibi-table monthly">
        <thead>
          <tr>
            <th>
              <div>車番</div>
            </th>
            <th>
              <div>担当乗務員名</div>
            </th>
            {日付List.map((i) => {
              // 休日マスタを参照し、休日は赤にする
              const is休日 = dateUtil.HolidayCheck(i, 休日List) !== 0
              const isSameDate = dayjs(i).isSame(
                dayjs(searchCondition.積日),
                "date"
              )
              return (
                <th
                  // スクロール用にID設定
                  id={isSameDate ? `monthlyKijunTumibi` : undefined}
                  className={["text-center", is休日 ? "holiday" : ""].join(" ")}
                  key={i}>
                  <div>{util.date.format(i, "MM/DD(ddd)")}</div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {乗務員List.map((車輌乗務員, rowIndex) => (
            <tr
              key={`${車輌乗務員.車輌ID}_${車輌乗務員.トレーラ車輌ID}_${車輌乗務員.乗務員ID}_${rowIndex}`}>
              <th className="syaryo-data">
                <div className="syaban">{車輌乗務員.車番}</div>
                <div className="fs-6">{車輌乗務員.車種区分名称1}</div>
                <div>{車輌乗務員.トレーラ車番}</div>
                <div className="fs-6">{車輌乗務員.トレーラ車種区分名称1}</div>
              </th>
              <th className="zyomuin-data">
                <div>{車輌乗務員.乗務員名}</div>
              </th>
              {日付List.map((str日付, i) => {
                const 受注配車 = 当日全配車(車輌乗務員, str日付)
                const key = `${車輌乗務員.車輌ID}_${車輌乗務員.トレーラ車輌ID}_${車輌乗務員.乗務員ID}_${rowIndex}_${str日付}`

                let cellClass = selectKey === key ? "select-cell" : ""

                const 欠勤データ = 車輌乗務員.欠勤リスト?.find((欠勤) =>
                  dayjs(欠勤.勤務日).isSame(dayjs(str日付), "date")
                )

                if (欠勤データ != null) {
                  switch (欠勤データ.勤怠区分 as T勤怠区分) {
                    case e勤怠区分.有給休暇:
                    case e勤怠区分.欠勤:
                    case e勤怠区分.慶忌休暇:
                    case e勤怠区分.特別休暇:
                      cellClass += " holiday"
                      break
                    default:
                      cellClass = ""
                      break
                  }
                }

                return (
                  <HaisyaTableCell
                    className={cellClass}
                    onClick={(e) => {
                      setSelectKey(key)
                      setSelectData({
                        車輌乗務員,
                        積日: searchCondition.積日,
                        受注配車: 受注配車,
                      })
                    }}
                    onContextMenu={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      select乗務員.current = 車輌乗務員
                      select積日.current = str日付
                      searchConditionRef.current = searchCondition
                      wjMenu?.show(e.nativeEvent)
                    }}
                    onDoubleClick={(_e) => {
                      setSelectKey(key)
                      setSelectData({
                        車輌乗務員,
                        積日: str日付,
                        受注配車: 受注配車,
                      })
                      setIsModalShow(true)
                    }}
                    date={str日付}
                    zyomuin={車輌乗務員}
                    haisoNo={受注配車.length > 0 ? 受注配車.length : 1}
                    key={key}>
                    {受注配車.length > 0 && (
                      <MonthlyHaisyaTableCard
                        zyomuin={車輌乗務員}
                        date={str日付}
                        chip={chip}
                        haisya={受注配車}></MonthlyHaisyaTableCard>
                    )}
                  </HaisyaTableCell>
                )
              })}
            </tr>
          ))}
        </tbody>
      </Table>
      <wjrInput.Menu
        initialized={menuInitialized}
        selectedValuePath="cmd"
        style={{ display: "none" }}
        isDroppedDownChanged={(dropDown: wjcInput.DropDown) => {
          if (dropDown.isDroppedDown) {
          } else {
            select乗務員.current = undefined
            select積日.current = undefined
          }
        }}
        itemClicked={(e: wjcInput.Menu) => {
          onMenuClick(e)
        }}
        header="Context Menu">
        <wjrInput.MenuItem cmd={e勤怠区分.有給休暇}>有給</wjrInput.MenuItem>
        <wjrInput.MenuItem cmd={e勤怠区分.特別休暇}>特休</wjrInput.MenuItem>
        <wjrInput.MenuItem cmd={e勤怠区分.欠勤}>欠勤</wjrInput.MenuItem>
        <wjrInput.MenuSeparator></wjrInput.MenuSeparator>
        <wjrInput.MenuItem cmd={undefined}>取消</wjrInput.MenuItem>
      </wjrInput.Menu>
    </div>
  )
}

export default MonthlyTab
